export var createPaymentAttemptId = function () { return window.crypto.randomUUID(); };
